import { useState } from "react";
import { Link } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";
import { FaBuilding } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";
import Menu from "./Menu";
import logo from "../../assets/logo.png";
import { BsGlobeCentralSouthAsia } from "react-icons/bs";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="w-full z-50 fixed top-0 left-0 bg-[#181D24] text-white">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-8 md:py-3 py-4">

        <div className="flex items-center gap-6">
           <a
            href="https://ajpgroup.c  om/"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-900 hover:bg-gray-800 transition border border-gray-700"
          >
            <BsGlobeCentralSouthAsia className="text-yellow-400" />
            <span className="text-xs font-sm font-[rufina]">MAIN MENU</span>
          </a>

           <div className="hidden md:block h-6 w-px bg-gray-700"></div>

          <Link to="/" className="flex items-center gap-5">
            <img
              src={logo}
              alt="AJP Logo"
              className="h-10 w-10 md:h-[40px] md:w-[40px]"
            />
            <span
              className="font-medium text-base md:text-[12px] tracking-[3px] md:tracking-[6px] uppercase text-[#F5F3F1]"
              style={{ fontFamily: 'Raleway' }}
            >

            </span>
          </Link>
        </div>

        {/* Desktop Navigation Menu */}
        <nav className="hidden md:flex items-center gap-6">
          <Menu />
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-white text-3xl"
        >
          {isOpen ? <HiX /> : <HiMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-[#030303] text-white px-4 py-2">
          {/* Mobile Menu Items */}
          <Menu mobile onLinkClick={() => setIsOpen(false)} />

          {/* Parent Company Link - Mobile View */}
          <div className="mt-4 pt-4 border-t border-gray-800">
            <a
              href="https://ajpgroup.com/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsOpen(false)}
              className="flex items-center justify-between px-4 py-3 rounded-lg bg-gray-900 hover:bg-gray-800 transition"
            >
              <div className="flex items-center gap-3">
                <BsGlobeCentralSouthAsia className="text-yellow-400 text-lg" />
                <span className="text-xs font-sm font-[rufina] ">MAIN MENU</span>
              </div>
              <FiExternalLink className="text-gray-400" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;